import React, { useState } from 'react';
import { loadTransferRules, saveTransferRules, SUGGESTED_TRANSFER_RULES } from '../utils/mcTransferRules';

export default function McTransferRules({ orgId = '', scope = 'ALL', siteLabel = 'All sites', onSaved = () => {} }) {
  const [fields, setFields] = useState(() => loadTransferRules({ orgId, scope }).policy || { ...SUGGESTED_TRANSFER_RULES });
  const [errors, setErrors] = useState([]);
  const [saved, setSaved] = useState(false);
  const change = (key, value) => { setFields((current) => ({ ...current, [key]: value })); setErrors([]); setSaved(false); };
  const field = (key, label, note) => <label><span>{label}</span><input type="number" min={key === 'targetCoverDays' || key === 'transferStep' ? '0.000001' : '0'} step="any" inputMode="decimal" value={fields[key]} onChange={(event) => change(key, event.target.value)} /><small>{note}</small></label>;
  const save = (event) => {
    event.preventDefault();
    const result = saveTransferRules({ orgId, scope, policy: fields });
    setErrors(result.errors);
    setSaved(result.ok);
    if (result.ok) onSaved(result.policy);
  };
  return <div className="mc-stockRules">
    <h4>Stock rules</h4>
    <p>Choose these once for {siteLabel}. Suggestions reuse them for other products on this device.</p>
    {String(scope).toUpperCase() === 'ALL' ? <p>These are the defaults for sites that have not saved their own stock rules.</p> : null}
    <form onSubmit={save} noValidate>
      <div className="mc-stockRulesGrid">
        {field('targetCoverDays', 'Days of stock at receiving sites', 'How long the suggested stock should last.')}
        {field('sourceReserve', 'Stock to keep at this site', 'Use this product’s stock unit, including 0.')}
      </div>
      <details><summary>More stock rules</summary><div className="mc-stockRulesGrid">
        {field('destinationMinimum', 'Minimum stock at receiving sites', 'Use 0 if you do not need a minimum.')}
        {field('transferStep', 'Send in multiples of', 'Use 1 for individual units, or your pack size.')}
      </div></details>
      {errors.length ? <ul className="mc-transferNotice" role="alert">{errors.map((error) => <li key={error}>{error}</li>)}</ul> : null}
      <div className="mc-transferSimpleActions"><button type="submit" className="mc-networkMovementBtn">Save stock rules</button>{saved ? <span role="status">Saved on this device.</span> : null}</div>
    </form>
  </div>;
}
